// extracted by mini-css-extract-plugin
export default {"navIcon":"BurgerButton_navIcon__+Vj5M","open":"BurgerButton_open__wd7Sy"};